import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretRight } from '@fortawesome/free-solid-svg-icons'
import * as RotatingArrowConstant from './RotatingArrowConstant'
import './styles.module.css'

export class RotatingArrow extends React.PureComponent {
    state = {
        rotatingArrowClass: this.props.isInitiallyExpanded
            ? 'fa-arrow-down'
            : 'fa-arrow-right',
        rotatingArrowState: this.props.isInitiallyExpanded
            ? RotatingArrowConstant.ARROW_ROTATION_STATE.DOWN
            : RotatingArrowConstant.ARROW_ROTATION_STATE.RIGHT
    }

    componentWillReceiveProps(newProps) {
        if (this.props.isRowExpanded !== newProps.isRowExpanded) {
            if (newProps.isRowExpanded) {
                this.setArrowRotationClass(
                    RotatingArrowConstant.ARROW_ROTATION_STATE.ROTATING_DOWN
                )
            } else {
                this.setArrowRotationClass(
                    RotatingArrowConstant.ARROW_ROTATION_STATE.ROTATING_RIGHT
                )
            }
        }
    }

    setArrowRotationClass(arrowState) {
        switch (arrowState) {
            case RotatingArrowConstant.ARROW_ROTATION_STATE.RIGHT:
                this.setState({ rotatingArrowClass: 'fa-arrow-right' })
                break
            case RotatingArrowConstant.ARROW_ROTATION_STATE.ROTATING_RIGHT:
                this.setState({ rotatingArrowClass: 'fa-arrow-rotating-right' })
                break
            case RotatingArrowConstant.ARROW_ROTATION_STATE.DOWN:
                this.setState({ rotatingArrowClass: 'fa-arrow-down' })
                break
            case RotatingArrowConstant.ARROW_ROTATION_STATE.ROTATING_DOWN:
                this.setState({ rotatingArrowClass: 'fa-arrow-rotating-down' })
                break
            default:
                break
        }
        this.setState({ rotatingArrowState: arrowState })
    }

    afterRotationSetArrowClass = () => {
        if (
            this.state.rotatingArrowState ===
            RotatingArrowConstant.ARROW_ROTATION_STATE.ROTATING_RIGHT
        ) {
            this.setArrowRotationClass(
                RotatingArrowConstant.ARROW_ROTATION_STATE.RIGHT
            )
        } else if (
            this.state.rotatingArrowState ===
            RotatingArrowConstant.ARROW_ROTATION_STATE.ROTATING_DOWN
        ) {
            this.setArrowRotationClass(
                RotatingArrowConstant.ARROW_ROTATION_STATE.DOWN
            )
        }
    }

    render() {
        return (
            <FontAwesomeIcon
                onAnimationEnd={this.afterRotationSetArrowClass}
                className={`fa-arrow ${this.state.rotatingArrowClass}`}
                icon={faCaretRight}
            />
        )
    }
}